import api from '../axios/axiosConfig';

export const getExtractHistory = async (filter = '30') => {
    try {
        const response = await api.get(`/wallet/History/${filter}`);
        return response
    } catch (error: any) {
        throw error;
    }
};

export const getOrderData = async (orderId : string) => {
    try {
        const response = await api.get(`/Payment/Order/${orderId}`);
        return response.data
    } catch (error: any) {
        throw error;
    }
};

export const getTransactionById = async (transactionId : string) => {
    try {
        const response = await api.get(`/UserTransactions/${transactionId}`);
        return response.data
    } catch (error: any) {
        throw error;
    }
};
